import React from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
type ScrollTableProps = {
  children: React.ReactNode;
};
export function ScrollTable({
  children
}: ScrollTableProps) {
  return <div data-id="element-249" data-mp="1fz50k3i9nrhy">
      <p className="mb-3 flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-wider text-neutral-500 md:hidden" data-id="element-250" data-mp="1fzde7xm7r0u7">
        <MoveHorizontalIcon className="h-4 w-4" aria-hidden="true" data-id="element-251" data-mp="1k0yxc0pccbcu" />
        Deslizá para ver la tabla completa
      </p>
      <div className="scroll-shadow overflow-x-auto rounded-2xl border border-line bg-surface" data-id="element-252" data-mp="27s4cedngizm3">
        {children}
      </div>
    </div>;
}